<mapfre-header></mapfre-header>
<div class="container mapfre-content">
  <div class="ie-message" *ngIf="isIEBrowser">
    <mapfre-info-divs [additionDivClass]="'align-icon-bop'">
      <em>{{ "Internet Explorer is no longer supported." | translate }}</em
      ><br />
      <em>
        {{
          "Please use Chrome, Firefox, Safari, or Microsoft Edge for a better experience."
        }}</em
      >
    </mapfre-info-divs>
  </div>
  

  <section class="mapfre-content details">
    <mapfre-card
      additionalClasses="signup guest-payment-container"
      [additionalCardContentClasses]="'ach-payment'"
    >
      <app-billing-confirm
        [ach_policyId]="policyId"
        [achBilling]="true"
      ></app-billing-confirm>
    </mapfre-card>
  </section>
</div>
